import { axiosMicroservice } from 'src/api/axios';

import type { TpStripeGetProductId } from '@features/Stripe/types';

export const getStripeProductId = async ({
  variant,
  app = 'FaceYoga',
}: TpStripeGetProductId): Promise<{
  pltv?: string;
  product_id: string;
  us_pltv?: string;
  us_product_id: string;
}> => {
  const { data } = await axiosMicroservice.get(
    `stripe/products_map?app=${app}&variant=${variant}`,
  );
  return data;
};
